var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{attrs:{"disabled":_vm.disabled,"type":_vm.type,"placeholder":_vm.placeholder},scopedSlots:_vm._u([{key:"icon-calendar",fn:function(){return [_c('i',{class:[_vm.icon],staticStyle:{"font-size":"18px"}})]},proxy:true}]),model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }